import { render, staticRenderFns } from "./service-type.vue?vue&type=template&id=20e54298&scoped=true&"
import script from "./service-type.vue?vue&type=script&lang=js&"
export * from "./service-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e54298",
  null
  
)

export default component.exports